/**
 * Nút Reload dùng chung cho MỌI dashboard report (Commercial Position, Futures
 * Position, Risk, Long-Short, Inventory, Cashflows) — trước đây copy y hệt 6 lần.
 *
 * Responsive: mobile (xs) icon-only (ẩn chữ "Reload" + zero margin startIcon để
 * icon căn giữa), sm+ hiện full chữ. `refetch()` ép gọi lại API kể cả khi args
 * không đổi (pattern BatchReportPage). Bọc trong <span> để Tooltip hoạt động khi
 * button disabled lúc đang fetch.
 */
import RefreshIcon from '@mui/icons-material/Refresh'
import { Box, Button, CircularProgress, Tooltip } from '@mui/material'

import { HIDE_ON_MOBILE_INLINE } from '../../../theme/responsive'

export function ReportReloadButton({
  loading,
  onClick,
}: {
  /** isFetching — disable + spinner + mờ trong lúc gọi lại API. */
  loading: boolean
  /** refetch() của RTK query. */
  onClick: () => void
}) {
  return (
    <Tooltip title="Reload dashboard data">
      <span>
        <Button
          size="small"
          variant="outlined"
          onClick={onClick}
          disabled={loading}
          title="Reload"
          startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <RefreshIcon sx={{ fontSize: 16 }} />}
          sx={{
            textTransform: 'none',
            py: 0.25,
            px: { xs: 0.5, sm: 1 },
            minWidth: { xs: 32, sm: 'auto' },
            minHeight: 28,
            fontSize: '0.75rem',
            // Mobile icon-only: bỏ margin startIcon để icon căn giữa (chữ ẩn).
            '& .MuiButton-startIcon': { margin: { xs: 0, sm: undefined } },
          }}
        >
          <Box component="span" sx={HIDE_ON_MOBILE_INLINE}>Reload</Box>
        </Button>
      </span>
    </Tooltip>
  )
}
